import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const USER_SELECTOR_LIST_ITEM_CLASS_NAME = 'UserSelectorListItem';
export const USER_SELECTOR_LIST_ITEM_CLASS_SLOTS = ['root'] as const;

export type UserSelectorListItemClassSlot =
	(typeof USER_SELECTOR_LIST_ITEM_CLASS_SLOTS)[number];

export interface UserSelectorListItemClasses {
	root: string;
	selected: string;
}

export type UserSelectorListItemClassKey = keyof UserSelectorListItemClasses;

export const getUserSelectorListItemUtilityClass = (slot: string) =>
	generateUtilityClass(USER_SELECTOR_LIST_ITEM_CLASS_NAME, slot);

export const userSelectorListItemClasses = generateUtilityClasses<
	keyof UserSelectorListItemClasses
>(USER_SELECTOR_LIST_ITEM_CLASS_NAME, ['root', 'selected']);
export default userSelectorListItemClasses;
